module.exports = __webpack_public_path__ + "img/b5e4b1e.webp";